<script>
    import { Chip, Typography } from '$lib/components/UI'
    import Point from './Point.svelte';
    import { createEventDispatcher } from 'svelte'
    import picker from '../../../../src/assets/picker.svg'
    export let i = 0
    export let data = {}
    const dispatch = createEventDispatcher()
    function onClick() {
        dispatch('click')
    }
        
    $: desc = `${data.calle} ${data.numero}`

    const schemaStates = {
        'Revision de modificaciones': {color: '#FF9F00', label: 'Cambios solicitados'},
        'Pendiente de aprobacion': {color: '#FF9F00', label: 'En aprobación'}
    }

    const colors = {
        Activa: '#437F4F',
        Inactiva: '#E9573D',
        'En aprobación': '#FF9F00',
        'Cambios solicitados': '#FF9F00',
        Rechazada: '#c21b17'
    }
    $: state = data.lfstate === 'Habilitada' ? (data.activa ? 'Activa' : 'Inactiva') : schemaStates[data.lfstate]?.label || data.lfstate;
    $: pending = state === 'Cambios solicitados'
</script>

<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
<div class="employe" on:click={onClick} on:keypress={onClick} tabindex={i + 1}>
    <div class="gradient">
        <Chip style={`padding: 4px ${pending ? '5px' : '9px'} 4px 9px`} color={colors[state]}>
            <span style="display: flex; flex-direction: row; justify-content: center; align-items: center">
                {state}
                {#if pending}
                    <Point afirmative={data.activa} alt={`${state} ${pending && data.activa ? "(Sucursal Activa)" : "(Sucursal Inactiva)"}`}/>
                    <!-- <Point afirmative={data.activa}>{data.activa ? 'Activa' : 'Inactiva'}</Point> -->
                {/if}
            </span>
        </Chip>
    </div>
    <span>
        <div class="avatar" style="background-image: url({picker})"></div>
    </span>
    <span class="title" title={desc}>
        <Typography style="margin: 0; padding: 0" type="h4">{data?.nombre}</Typography>
        <Typography color="grey-400" style="margin: 0; padding: 0" type="h5" title="{desc}">{desc.slice(0, 35)}</Typography>
    </span>
</div>

<style>
    .gradient {
        position: absolute;
        bottom: 20px;
        right: 25px;
        display: flex;
        justify-content: end;
        background-color: red;
        align-items: top;
        padding: 0 0 10px 20px;
        background-color: transparent;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 15%);
    }
    .avatar {
        width: 64px;
        height: 64px;
        display: block;
        background-repeat: no-repeat;
        background-size: contain;
    } 
    .employe {
        user-select: none;
        gap: 15px;
        display: flex;
        min-width: 375px;
        max-width: 400px;
        width: auto;

        cursor: pointer;
        height: 115px;
        background: white;
        box-shadow: var(--shadow-default);
        position: relative;
        border-radius: 9px;
        padding: 25px;
    }
    .employe span {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 5px;
    }
</style>
